import React from "react";
import { Banner, Layout, LegacyStack, ButtonGroup } from "@shopify/polaris";
import { getObject, setObject } from "../../utils/LocalStorageExpiry";

const ReviewCard = () => {
  const [dismissed, setDismissed] = React.useState(
    getObject("reviewCardDismissed") || false,
  );

  React.useEffect(() => {
    setObject("reviewCardDismissed", dismissed);
  }, [dismissed]);

  return (
    !dismissed && (
      <Layout.Section>
        <Banner
          title="Would you recommend Disco? ☆☆☆☆☆"
          tone="success"
          onDismiss={() => setDismissed(true)}
        >
          <LegacyStack vertical="true" spacing="tight">
            <div style={{ marginTop: "0.25rem" }}>
              Thank you for using Disco through BFCM!
            </div>
            <div style={{ marginBottom: "0.25rem" }}>
              If you were happy with the app & support, we would be so grateful
              if you would leave a rating. Thank you!
            </div>
            <ButtonGroup>
              <div className="Polaris-Banner__PrimaryAction">
                <a
                  className="Polaris-Button Polaris-Button--outline"
                  href="//apps.shopify.com/discount-app#modal-show=ReviewListingModal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Leave a rating
                </a>
              </div>
            </ButtonGroup>
          </LegacyStack>
        </Banner>
      </Layout.Section>
    )
  );
};

export default ReviewCard;
